export const TOGGLE_ANALYTICS_LOGGING = 'toggleAnalyticsLogging';
export const TOGGLE_PUBNUB_LOGGING = 'togglePubnubLogging';
